<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">DHCP Option82 Config</div> 
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the config of DHCP Option82." }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--global config-->
        <pane label="Global">
          <dhcp-option82-global></dhcp-option82-global>
        </pane>
        <!--interface config-->
        <pane label="Interface">
          <dhcp-option82-interface></dhcp-option82-interface>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs.vue"
import Pane from "@/components/Pane.vue"
import DhcpOption82Global from "@/views/DhcpOption82GlobalConfig.vue"
import DhcpOption82Interface from "@/views/DhcpOption82PortConfig.vue"

export default {
  components: {
    Tabs,
    Pane,
    DhcpOption82Global,
    DhcpOption82Interface,
  },
  data() {
    return {
      activeIndex: 0,
    }
  },
}
</script>

